import log from 'salvo-lite/log'

class CopyToClipboard {
    constructor (theme, elem) {
        this.theme = theme
        this.elem = elem
        this.copy = this.elem.querySelector('.copy')
        this.title = this.elem.querySelector('.faq-text')
        this.content = this.elem.querySelector('.accordion-content')
        this.url = window.location.href
        this.id = this.elem.querySelector('.urlanchor').id
        log.debug(this.constructor.name, 'Constructed', this)
        this.base = window.location.origin + window.location.pathname
    }
    onInit () {
        if (this.url.includes(this.id)) {
            this.title.classList.add('active')
            this.content.style.display = 'block'
        }
        this.copy.addEventListener('click', () => {
            let copyurl = this.base + '#' + this.id
            var hidden = document.createElement('input')
            document.body.appendChild(hidden)
            hidden.setAttribute('id', 'hidden_id')
            document.getElementById('hidden_id').value = copyurl
            hidden.select()
            document.execCommand('copy')
            document.body.removeChild(hidden)
        })
    }
}

export default CopyToClipboard



// WEBPACK FOOTER //
// ./src/resources/scripts/components/CopyToClipboard.js